import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Image,
  Input,
  InputGroup,
  InputRightElement,
  Text,
  useToast,
} from "@chakra-ui/react";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AiOutlineLock, AiOutlineMail } from "react-icons/ai";
import leftsideimage from "../Logins/assets/leftsideimage.PNG";
import jwt_decode from "jwt-decode";
import { useDispatch, useSelector } from "react-redux";
import { AuthContext } from "../../Context/AuthContext";
import { UserloginTest } from "../../Redux/auth/action";
import { getUsers } from "../../Redux/app/action";

const UserLogin = () => {
  const token = useSelector((store) => store.authentication);
  const globalState = useSelector((store) => store.authentication.data.token);
  const isAuth = useSelector((store) => store.authentication.data.isAuth);
  const extra = useSelector((store) => store.authentication.data.extra);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getUsers());
  }, [dispatch]);

  const [usercred, setUerCed] = useState({});
  const toast = useToast();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUerCed({
      ...usercred,
      [name]: value,
    });
  };

  const handleLogin = (e) => {
    e.preventDefault();
    dispatch(UserloginTest(usercred));
  };

  useEffect(() => {
    if (token.data.token.token) {
      if (token.data.token.role.toLowerCase() === "employee") {
        navigate("/employee");
        toast({
          position: "top",
          title: `Welcome Back ${globalState.sudo_name}`,
          description: "Sucessfully Logged In",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      } else {
        toast({
          position: "top",
          title: "Warning",
          description: "Check the correct routes of credentials",
          status: "warning",
          duration: 3000,
          isClosable: true,
        });
      }
    } else if (extra === "extraAuth" && !isAuth) {
      navigate("/");
      toast({
        position: "top",
        title: "Invalid Credentials",
        description: "Enter the correct credentials",
        status: "error",
        duration: 500,
        isClosable: true,
      });
    }
  }, [
    token,
    globalState.role,
    globalState.sudo_name,
    globalState.token,
    navigate,
    toast,
    extra,
    isAuth,
  ]);

  return (
    <>
      <Flex flexWrap="wrap" justifyContent="center">
        <Box p={{ base: "none", md: 10 }} bg={"white"}>
          <Image
            p={{ base: "none", md: 10 }}
            width={{ base: "100%", sm: "45%", md: "80%" }}
            src={leftsideimage}
          />
        </Box>

        <Box p={20} bg={"white"} width={{ base: "100%", sm: "45%", md: "40%" }}>
          <form onSubmit={handleLogin}>
            <FormControl>
              <Text fontSize="3xl" fontWeight={"bold"} textAlign={"start"}>
                SIGN IN TO EMPLOYEE E&D 360
              </Text>
              <br />
              <br />
              <Flex flexWrap="wrap" justifyContent="space-between">
                <Button
                type="submit"
                w={"full"}
                textColor={"white"}
                background={"#00ab55"}
                _hover={{ textColor: "white", background: "#00ab55" }}
              >
                Admin Login
              </Button>
                <Button
                type="submit"
                w={"full"}
                textColor={"white"}
                background={"#00ab55"}
                _hover={{ textColor: "white", background: "#00ab55" }}
              >
                Company Login
              </Button>
              </Flex>
              <br />
              <br />
              <Flex alignItems="center">
                <Box
                  flex="1"
                  borderBottom="1px solid"
                  borderColor="gray.400"
                  mr="4"
                />
                <Text
                  fontWeight="medium"
                  textTransform="uppercase"
                  textColor={"gray"}
                >
                  OR
                </Text>
                <Box
                  flex="1"
                  borderBottom="1px solid"
                  borderColor="gray.400"
                  ml="4"
                />
              </Flex>
              <br />
              <FormLabel>Employee Id </FormLabel>
              <InputGroup>
                <Input
                  type="text"
                  id="employee_id"
                  name="employee_id"
                  placeholder="Enter Employee Id"
                  onChange={handleChange}
                  required
                />
                <InputRightElement
                  style={{ background: "#00ab55" }}
                  pointerEvents="none"
                  children={<AiOutlineMail color="white" />}
                />
              </InputGroup>
              <br />
              <FormLabel>Password</FormLabel>
              <InputGroup>
                <Input
                  type="password"
                  id="password"
                  name="password"
                  placeholder="Employee Password"
                  onChange={handleChange}
                  required
                />
                <InputRightElement
                  style={{ background: "#00ab55" }}
                  pointerEvents="none"
                  children={<AiOutlineLock color="white" />}
                />
              </InputGroup>
              <br />

              <Button
                type="submit"
                w={"full"}
                textColor={"white"}
                background={"#00ab55"}
                _hover={{ textColor: "white", background: "#00ab55" }}
              >
                Login Now
              </Button>
            </FormControl>
          </form>
        </Box>
      </Flex>
    </>
  );
};

export default UserLogin;
